import "../CSS/formAgregarUsuario.css";
import React, { useRef, useEffect, useState, Fragment } from "react";
import NavBar from "./NavBar";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import TextField from "@mui/material/TextField";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import ContactMailRoundedIcon from "@mui/icons-material/ContactMailRounded";
import PasswordRoundedIcon from "@mui/icons-material/PasswordRounded";
import { db } from "../FirebaseConfig/firebase";
import { useNavigate, useParams } from "react-router-dom";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import boleta from "../img/boleta.png";

import {
  getDoc,
  setDoc,
  doc,
  query,
  where,
  collection,
  getDocs,
  addDoc,
} from "firebase/firestore";
import axios from "axios";

const MySwal = withReactContent(Swal);
function FormIngresarPago() {
  const [nombres, setNombres] = React.useState(
    localStorage.getItem("nombreLocal") +
      " " +
      localStorage.getItem("apellidoLocal")
  );
  const [cip, setCip] = React.useState(localStorage.getItem("idLocal"));
  const [nroSerie, setNroSerie] = React.useState("");
  const [correlativo, setCorrelativo] = React.useState("");
  const [monto, setMonto] = React.useState("");
  const [pbVisible, setpbVisible] = React.useState(false);

  const [isNew, setIsNew] = React.useState(true);
  const [listaRegistro, setListaRegistro] = React.useState([]);

  const [idDocReserva, setidDocReserva] = React.useState("----");

  const [pagosDiferidos, setPagosDiferidos] = useState([]);
  const [pagosEncontrados, setPagosEncontrados] = useState([]);
  const [listaCupones, setListaCupones] = useState([]);

  const navigate = useNavigate();
  const { id } = useParams();

  const comunicadosList = collection(db, "USUARIOS");
  const buscarPagosDiferidos = async () => {
    const cuponesList = collection(db, `TIPOSDEPAGOS`);
    const data = await getDocs(cuponesList);
    const tickets = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    //console.log(tickets);
    setPagosDiferidos(tickets);
  };
  const buscarCodigoCip = async () => {
    //console.log("Buscar codigo " + CIP);
    const q = query(collection(db, "USUARIOS"), where("cip", "==", cip));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      //VERIFICAR HABILIDAD CON DB
      //setCip(doc.id);
      //buscarIdAsientoUser();
      setNombres(doc.data().nombre + " " + doc.data().apellidos);
      setCip(doc.data().cip);
    });
  };

  const buscarCupones = async () => {
    const cuponesList = collection(db, `EVENTOS/${id}/CUPONES`);
    const data = await getDocs(cuponesList);
    const tickets = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    setListaCupones(tickets);
  };

  const handleClick = () => {
    Swal.fire({
      title: "Ingresa el código del cupón",
      input: "text",
      showCancelButton: true,
      confirmButtonText: "Buscar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const cuponesList = collection(db, `EVENTOS/${id}/CUPONES`);
        const data = await getDocs(cuponesList);
        const tickets = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));

        const cuponEncontrado = tickets.find(
          (cupon) => cupon.codigo === result.value
        );
        if (cuponEncontrado) {
          if (cuponEncontrado.estado == "Usado") {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "El cupón ya fue usado",
              showConfirmButton: false,
              timer: 3000,
            });
          } else {
            if (cuponEncontrado.cip != cip) {
              Swal.fire({
                position: "center",
                icon: "error",
                title:
                  "El cupón no aplica para el usuario con codigo CIP " + cip,
                showConfirmButton: false,
                timer: 3000,
              });
            } else {
              localStorage.setItem("totalEntradas", cuponEncontrado.asientos);
              localStorage.setItem("flagEntradas", true);
              localStorage.setItem("cupon", true);
              localStorage.setItem("codigocupon", cuponEncontrado.id);

              navigate(`../eventos/${id}/registrarParticipanteSalon`);
            }
          }
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Cupón no encontrado",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      }
    });
  };
  const validarFormulario = () => {
    if (
      correlativo == "" ||
      monto == "" ||
      nroSerie == "" ||
      nombres == "" ||
      cip == ""
    ) {
      MySwal.fire("", "Llenar todos los campos", "error");
    } else {
      revisarPago();
    }
  };
  const obtenerAsientosRegistrados = async () => {
    const q = query(
      collection(
        db,
        `USUARIOS/${localStorage.getItem("idDocumento")}/AsientosRegistrados`
      ),
      where("idEvento", "==", id)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      console.log("buscando asiento " + doc.data().idEntrada);
      setidDocReserva(doc.data().idEntrada);
      setIsNew(false);
    });
  };
  const validarmonto = async (monto) => {
    try {
      const res = await axios.get(
        `https://cip-cda-registro-production.up.railway.app/listaPagos/${correlativo}/${nroSerie}`
      );
      const miArreglo = [];
      res.data.forEach(function (elementoRecibo) {
        pagosDiferidos.forEach(function (elementoPagosDiferidos) {
          console.log(
            "Codido fire " +
              elementoRecibo.vtipope +
              " CodigoLocal " +
              elementoPagosDiferidos.Codigo
          );
          //console.log("ENCONTRO - prueba " + elementoRecibo.ncan);

          if (elementoRecibo.vtipope == elementoPagosDiferidos.Codigo) {
            console.log("ENCONTRO " + elementoRecibo.ncan);
            for (let i = 0; i < parseInt(elementoRecibo.ncan); i++) {
              miArreglo.push(elementoPagosDiferidos);
            }
          }
        });
      });
      setPagosEncontrados(miArreglo);
      console.log(miArreglo);
      const miObjeto = {
        nroSerie: nroSerie,
        correlativo: correlativo,
        monto: monto,
      };
      localStorage.setItem("detallesRecibo", JSON.stringify(miObjeto));

      localStorage.setItem("totalEntradas", miArreglo.length);
      localStorage.setItem("flagEntradas", true);

      if (miArreglo.length >= 1) {
        MySwal.fire(
          "",
          "Se encontraron " + miArreglo.length + " entradas pagadas",
          "warning"
        );
        setpbVisible(false);
        navigate(`../eventos/${id}/registrarParticipanteSalon`);
      } else {
        MySwal.fire("", "No se encontraron entradas pagadas", "warning");
        setpbVisible(false);
      }
    } catch (err) {
      MySwal.fire("", "DATOS DE PAGO INCORRECTO", "warning");
      setpbVisible(false);
    }
  };
  const revisarPago = async (e) => {
    setpbVisible(true);

    //console.log("corr " + correlativo + "serie " + nroSerie + "monto " + monto);
    try {
      const res = await axios.get(
        `https://cip-cda-registro-production.up.railway.app/pagos/${correlativo}/${nroSerie}/${monto}`
      );
      //console.log(res.data[0]);
      if (res.data[0].vnumdoc.includes(correlativo)) {
        setCorrelativo(res.data[0].vnumdoc);
        setNroSerie(res.data[0].vserdoc);
        //setMonto(res.data[0].nvaltot);

        if (res.data[0].ncodcli != cip) {
          MySwal.fire(
            "",
            "El recibo no coincide con el Codigo CIP " +
              localStorage.getItem("idLocal"),
            "warning"
          );
          setpbVisible(false);
        } else {
          if (isNew) {
            validarmonto(monto);
          } else {
            const listaref = collection(
              db,
              `EVENTOS/${id}/AsientosRegistrados/${idDocReserva}/reciboPago`
            );
            const q = query(listaref);
            const documentSnapshot = await getDocs(q);
            var flboucherduplicado = true;
            if (documentSnapshot.size > 0) {
              console.log("OTROS BOUCHERS ENCONTRADOS");
              var sumatotal = 0;
              documentSnapshot.forEach((doc) => {
                console.log(
                  "correlativo  " +
                    (correlativo.includes(doc.data().correlativo) ||
                      doc.data().correlativo.includes(correlativo))
                );
                console.log(
                  "nroSerie  " + nroSerie.includes(doc.data().nroSerie)
                );
                if (
                  (correlativo.includes(doc.data().correlativo) ||
                    doc.data().correlativo.includes(correlativo)) &&
                  (nroSerie.includes(doc.data().nroSerie) ||
                    doc.data().nroSerie.includes(nroSerie)) &&
                  monto == doc.data().monto
                ) {
                  console.log("BOUCHER DUCPLICADO");
                  flboucherduplicado = false;
                  MySwal.fire(
                    "",
                    "ESTE RECIBO YA FUE USADO ANTERIORMENTE",
                    "warning"
                  );
                  setpbVisible(false);
                } else {
                  sumatotal = parseInt(doc.data().monto);
                }
              });
              if (flboucherduplicado) {
                sumatotal = parseInt(monto);

                console.log("suma total es " + sumatotal);
                validarmonto(sumatotal);
              }
            } else {
              console.log("NO HAY OTROS BOUCHERS");
              validarmonto(monto);
            }
          }
        }
      } else {
        MySwal.fire("", "DATOS DE PAGO INCORRECTO", "warning");
        setpbVisible(false);
      }
    } catch (err) {
      MySwal.fire("", "DATOS DE PAGO INCORRECTO", "warning");
      setpbVisible(false);
    }
  };

  //cerrar detalles comunicado
  const cerrar = () => {
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      navigate("../panelUser/eventos");
    } else {
      if (localStorage.getItem("nivelUsuario") == "admin") {
        navigate("../panelAdmin/eventos");
      } else {
        navigate("../login");
      }
    }
  };

  useEffect(() => {
    if (localStorage.getItem("nivelUsuario") == "admin") {
      setCip("");
      setNombres("");
    }
    buscarPagosDiferidos();
    obtenerAsientosRegistrados();
    buscarCupones();
    localStorage.setItem("cupon", false);
  }, []);
  return (
    <Fragment>
      <NavBar
        titulo="Ingresar recibo de pago"
        imagen="cerrar"
        logoTitulo="usuarios"
        cerrar={cerrar}
      ></NavBar>

      <div className="fau-agregarUsuarios">
        <div className="fau-card">
          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PersonRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />

                <TextField
                  disabled={
                    localStorage.getItem("nivelUsuario") == "admin"
                      ? false
                      : true
                  }
                  sx={{ width: 350 }}
                  label="Numero CIP"
                  variant="standard"
                  type="number"
                  value={cip}
                  onChange={(e) => setCip(e.target.value)}
                />
                <div className="navbar-right" type="submit">
                  <img
                    src={require(`../img/buscar.png`)}
                    type="submit"
                    alt="salir"
                    className="salida"
                    style={{
                      cursor: "pointer",
                      visibility:
                        localStorage.getItem("nivelUsuario") == "admin"
                          ? "visible"
                          : "hidden",
                    }}
                    onClick={() => buscarCodigoCip()}
                  />
                </div>
              </Box>
            </Box>
          </div>
          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PersonRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  disabled={
                    localStorage.getItem("nivelUsuario") == "admin"
                      ? false
                      : true
                  }
                  sx={{ width: 350 }}
                  label="Nombres y Apellidos"
                  value={nombres}
                  variant="standard"
                  onChange={(e) => setNombres(e.target.value)}
                />
              </Box>
            </Box>
          </div>

          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <ContactMailRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Numero de Serie"
                  variant="standard"
                  type="number"
                  value={nroSerie}
                  onChange={(e) => setNroSerie(e.target.value)}
                />
              </Box>
            </Box>
          </div>

          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PasswordRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Correlativo"
                  value={correlativo}
                  variant="standard"
                  onChange={(e) => setCorrelativo(e.target.value)}
                />
              </Box>
            </Box>
          </div>
          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <MonetizationOnIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Monto"
                  value={monto}
                  variant="standard"
                  onChange={(e) => setMonto(e.target.value)}
                />
              </Box>
            </Box>
          </div>
          <div
            style={{
              width: "180px",
              textAlign: "center",
              alignItems: "center",
              placeContent: "center",
            }}
          ></div>

          <div className="fau-formNumber">
            <div className="fau-addUser">
              {pbVisible ? (
                <LinearProgress color="success" style={{ marginBottom: 20 }} />
              ) : null}

              <input
                type="submit"
                value="Buscar Recibo"
                className="fau-btnAgregarComunicado"
                onClick={validarFormulario}
              />
            </div>
          </div>
        </div>
        <div className="fau-card">
          <img
            id="imagenTienda"
            src={boleta}
            alt="logo-titulo"
            className="imagenEmpresa"
          />
          <div className="fau-addUser">
            <p>
              Tienes un cupón? &nbsp;
              <span
                onClick={handleClick}
                style={{ color: "blue", cursor: "pointer" }}
              >
                Ingrésalo aquí
              </span>
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default FormIngresarPago;
